// extracted by mini-css-extract-plugin
module.exports = {"rentRoomContainer":"RentRoomList_rentRoomContainer__1hm99","roomSelector":"RentRoomList_roomSelector__3Pg1r","deleteBtn":"RentRoomList_deleteBtn__usBZE"};